var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-mask',{staticClass:"form-control",class:_vm.getClass,attrs:{"mask":_vm.mask,"name":_vm.name,"type":"text","masked":true,"placeholder":_vm.placeholder,"inputmode":_vm.inputmode},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }